// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"ddc2fa34ca750ccd27b3","532":"0f4d1a432b5ac0dabc70","691":"ad4ce74006bd6a9e7792"}[chunkId] + ".js";
};